module.exports = __webpack_public_path__ + "static/img/lianxiwomen.6318e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/lianxiwomen.jpg
// module id = qYTk
// module chunks = 6